import React from 'react';
import _ from 'lodash';

import { getErrorValidateWithId, handleResetFieldTreeWorks } from '../../../utilities/works';
import CellContent from './CellContent';
import { Dropdown } from '../../dropdowns/portal';
import FieldTreeService from '../../../services/FieldTrees';
import SessionStorageService from '../../../services/utilities/SessionStorageService';
import Loader from '../../Loader';

const fieldId = SessionStorageService.getFieldId();

const PartnerCompanyTemplate = ({
  grid,
  context,
  msgValidate,
  handlePushParam,
  column,
}) => {
  const {
    id,
    work_date,
    company_name,
    field_tree_id,
    work_group: { work_hour_zone },
    isAbortedOrApproved,
  } = context.item;

  const handleSetData = async data => {
    //handle auto check job if have 1 result
    Loader.start();
    const job = await getWorkJob(data.field_tree_id);
    let jobId = null;
    let jobName = '';
    let foremanUserId = null;
    let foremanUserName = '';
    let foreman = null;
    if (job) {
      jobId = job.job_id;
      jobName = job.name;
      //handle auto check foreman if have 1 result
      foreman = await getForemanUser(data.field_tree_id, jobId);
      if (foreman) {
        foremanUserId = foreman.user_id;
        foremanUserName = foreman.user_name;
      }
    }
    Loader.done();
    const v = grid.collectionView;
    v.editItem(v.currentItem);
    v.currentItem['company_name'] = data.name;
    v.currentItem['field_tree_id'] = data.field_tree_id;
    v.currentItem['job_id'] = jobId;
    v.currentItem['job_name'] = jobName;
    v.currentItem['foreman_user_id'] = foremanUserId;
    v.currentItem['foreman_user_name'] = foremanUserName;
    if (!v.currentItem['is_data_changed']['field_tree_id']) {
      v.currentItem['is_data_changed']['field_tree_id'] = true;
    }
    if (jobId && !v.currentItem['is_data_changed']['job_id']) {
      v.currentItem['is_data_changed']['job_id'] = true;
    }
    if (foreman && !v.currentItem['is_data_changed']['foreman_user_id']) {
      v.currentItem['is_data_changed']['foreman_user_id'] = true;
    }
    v.commitEdit();
    handlePushParam(context.item, 'field_tree_id');
  };

  const getError = () => {
    return getErrorValidateWithId(msgValidate, context.item, 'field_tree_id');
  };

  const getWorkJob = async fieldTreeId => {
    const params = {
      is_limit: 1,
      offset: 0,
      limit: 2,
      field_tree_id,
      date_to: work_date,
      field_id: fieldId,
      display_flag: 1,
    };
    try {
      const response = await FieldTreeService.treeJobs(
        fieldId,
        fieldTreeId,
        params,
        false
      );
      if (!response.result) {
        return null;
      }
      const responseData = _.get(response, 'data.entities.jobs', []);
      return _.size(responseData) === 1 ? responseData[0] : null;
    } catch (error) {
      handleResetFieldTreeWorks(grid, handlePushParam, context, error);
      return null;
    }
  };

  const getForemanUser = async (fieldTreeId, jobId) => {
    const params = {
      is_limit: 1,
      offset: 0,
      limit: 2,
      field_id: fieldId,
      date_to: work_date,
      job_id: jobId,
    };
    try {
      const response = await FieldTreeService.treeUsers(
        fieldId,
        fieldTreeId,
        params,
        false
      );
      if (!response.result) {
        return null;
      }
      const responseData = _.get(response, 'data.entities', []);
      return _.size(responseData) === 1
        ? responseData[0]['field_tree_user']
        : null;
    } catch (error) {
      handleResetFieldTreeWorks(grid, handlePushParam, context, error);
      return null;
    }
  };

  const getCompanies = params => {
    if (!context.item.work_date) {
      return null;
    }
    return FieldTreeService.selectableCompaniesList(fieldId, {
      ...params,
      date_to: work_date,
      work_hour_zone,
      field_id: fieldId,
    });
  };

  return (
    <CellContent
      errorMsg={getError()}
      isDataChanged={_.get(context, 'item.is_data_changed.field_tree_id')}
      errorTooltipId={`cell_${_.get(context, 'col.index')}_${_.get(
        context,
        'row.index'
      )}`}
      key={`${column}_${_.get(context, 'item.id')}`}
    >
      <Dropdown
        handleOnChange={handleSetData}
        name={company_name}
        value={field_tree_id}
        listForceReload={[work_date].toString()}
        callbackApi={getCompanies}
        responseKey='companies'
        fieldValue='field_tree_id'
        fieldName='name'
        isShowToolTip={true}
        key={id}
        label='協力会社を選択'
      >
        <Dropdown.Select readOnly={isAbortedOrApproved} />
        <Dropdown.List cssClass='dropdown__item--wide'>
          <Dropdown.Search />
          <Dropdown.RadioItems />
        </Dropdown.List>
      </Dropdown>
    </CellContent>
  );
};

export default PartnerCompanyTemplate;



// WEBPACK FOOTER //
// ./src/components/wijimo/templates/PartnerCompanyTemplate.jsx